export const emptyRequest: () => Promise<void> = (): Promise<void> => {
  return new Promise<void>((resolve: () => void): void => {
    resolve();
  });
};
